import type { AddNewProfileRequestProps } from '@services/api/accessProfile/types'
import type { AddNewProfileModalFormProps } from '../components/AddNewProfileModal/form/types'

export const parseAddNewProfilePayload = (formData: AddNewProfileModalFormProps) => {
  const payload: AddNewProfileRequestProps = {
    bodyParams: {
      profileName: formData.profileDescription,
      profileType: formData.profileType,
      isActive: !!(formData.status === 'Ativo'),
      observations: formData.observations
    }
  }

  return payload
}
